export default "__VITE_ASSET__C8Qf0InL__"